import client from './client';
import qs from 'qs';

const approvalV2Url = '/api/v1/common/approval/v2';

export const getApprovalV2Lines = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${approvalV2Url}/lines${queryString ? `?${queryString}` : ''}`);
};

export const getApprovalV2Line = (lineId) => {
  return client.get(`${approvalV2Url}/lines/${lineId}`);
};

export const addApprovalV2Line = (data) => {
  return client.post(`${approvalV2Url}/lines`, data);
};

export const editApprovalV2Line = (lineId, data) => {
  return client.put(`${approvalV2Url}/lines/${lineId}`, data);
};

export const removeApprovalV2Line = (lineId) => {
  return client.delete(`${approvalV2Url}/lines/${lineId}`);
};

export const getApprovalV2Delegations = () => {
  return client.get(`${approvalV2Url}/delegations/my`);
};

export const getApprovalV2Inbox = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${approvalV2Url}/inbox${queryString ? `?${queryString}` : ''}`);
};

export const getApprovalV2Submitted = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${approvalV2Url}/submitted${queryString ? `?${queryString}` : ''}`);
};

export const getApprovalV2Document = (apprDocId) => {
  return client.get(`${approvalV2Url}/documents/${apprDocId}`);
};

export const getApprovalV2DocumentByRef = ({ docType, refDocId }) => {
  const queryString = qs.stringify({ docType, refDocId });
  return client.get(`${approvalV2Url}/documents/ref?${queryString}`);
};

export const addApprovalV2Delegation = (data) => {
  return client.post(`${approvalV2Url}/delegations`, data);
};

export const editApprovalV2Delegation = (delegationId, data) => {
  return client.put(`${approvalV2Url}/delegations/${delegationId}`, data);
};

export const removeApprovalV2Delegation = (delegationId) => {
  return client.delete(`${approvalV2Url}/delegations/${delegationId}`);
};

export const getApprovalV2Auths = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${approvalV2Url}/auths${queryString ? `?${queryString}` : ''}`);
};

export const getApprovalV2AuthManagePermission = () => {
  return client.get(`${approvalV2Url}/auths/manage-permission`);
};

export const getMyFinalApprovalAuth = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${approvalV2Url}/auths/my-final${queryString ? `?${queryString}` : ''}`);
};

export const addApprovalV2Auth = (data) => {
  return client.post(`${approvalV2Url}/auths`, data);
};

export const editApprovalV2Auth = (authId, data) => {
  return client.put(`${approvalV2Url}/auths/${authId}`, data);
};

export const removeApprovalV2Auth = (authId) => {
  return client.delete(`${approvalV2Url}/auths/${authId}`);
};
